<header class="default-banner">
    <div class="container-fluid h-100">
        <section class="row d-flex-center-center h-100">
            <article class="default-banner__background" [ngStyle]="{ 'background-image': 'url(' + (partner?.bannerImage || '') + ')'}"></article>
            <article class="default-banner__content col-lg-8 col-sm-10 col-11 py-5">
                <div class="default-banner__header mb-md-5 mb-4">
                    <fitscovery-ui-markdown-viewer [content]="getHeader()" ></fitscovery-ui-markdown-viewer>
                </div>
                <div class="default-banner__description mb-md-5 mb-4">
                    <fitscovery-ui-markdown-viewer [content]="getSubHeader()" ></fitscovery-ui-markdown-viewer>
                </div>
                <section class="default-banner__buttons container">
                    <div class="row d-flex-center-center">
                      <button class="btn mr-md-4 mr-0 mb-md-0 mb-4 col-lg-3 col-md-4 col-sm-7 col-12"
                          [ngClass]="setButtonAlignmentClass(partnerButton!)"
                          [ngStyle]="{ background: partnerButton?.color || '#E34564' , color: partnerButton?.textColor || 'white' }"
                          *ngIf="partner?.appConfig!?.showCalendarButton" (click)="goToSchedule()">SEE OUR
                          SCHEDULE</button>
                      <a [href]="'mailto:'+ partner.contactInfo!.email" class="btn col-lg-3 col-md-4 col-sm-7 col-12"
                          [ngClass]="setButtonAlignmentClass(partnerButton!)"
                          [ngStyle]="{ background: partnerButton?.color || '#E34564' , color: partnerButton?.textColor || 'white' }"
                          *ngIf="partner?.appConfig!?.showContactMeButton && partner.contactInfo!?.email">SEND A
                          MESSAGE</a>
                    </div>
                    <div class="row d-flex-center-center">
                        <div class="d-flex" [ngClass]="setButtonAlignmentClass(partnerButton!)">
                          <ng-container *ngIf="partnerButton">
                            <fitscovery-ui-custom-button class="mx-lg-0 mx-auto" [button]="partnerButton" [email]="partner?.contactInfo!.email" [homePageVersion]="partner?.appConfig!.homePageVer!"></fitscovery-ui-custom-button>
                          </ng-container>
                        </div>
                    </div>
                </section>
            </article>
        </section>
    </div>
</header>